const ACCESS_TOKEN = "attorny_access_token" as string;
const REFRESH_TOKEN = "attorny_refresh_token" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ACCESS_TOKEN);
};

/**
 * @description get token form localStorage
 */
export const getRefreshToken = (): string | null => {
  return window.localStorage.getItem(REFRESH_TOKEN);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token_id: string, token: string): void => {
  window.localStorage.setItem(token_id, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (token_id: string): void => {
  window.localStorage.removeItem(token_id);
};

export default {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  getToken,
  getRefreshToken,
  saveToken,
  destroyToken,
};
